import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MyUser from '../../components/users/MyUser';
import { showPopup } from '../../actions/uiActions';
import { getCurrentUser } from '../../actions/userActions';

function MyUserContainer(props) {
    // trigger on component mount
    useEffect(() => {
        if (props.currentUser === null) {
            props.getCurrentUser(props.id)
        }
    });

    return <MyUser showPopup={props.showPopup} currentUser={props.currentUser} />;
}

function mapStateToProps(state) {
    return {
        currentUser: state.users.currentUser,
        id: state.users.userID,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ showPopup, getCurrentUser }, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(MyUserContainer)